export class BaseModel {
  constructor(data, defaults = {}) {
    const model = angular.extend({}, defaults, data);
    angular.extend(this, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/base/model.js